const mutations = {
  SET_MENU_LIST(state, list) {
    // 不要なはず
    state.menuList = list
  },
  SET_ADVERTISER_LIST(state, list) {
    state.advertiserList = list
  },
  SET_INSERTION_ORDER_LIST(state, list) {
    state.insertionOrderList = list
  },
  SET_SEARCH_RESULT(state, searchResult) {
    state.searchResult = searchResult
  },
}

export default mutations
